export default {
  titles: {
    default: 'Reminder comandă programată!',
    external_delivery: 'Șofer atribuit!',
  },
  labels: {
    pickup: 'Ridicare: {{time}}',
    preparation_time: 'Timp de pregătire: {{time}} min',
  },
  buttons: {
    confirm: 'Începe pregătirea acum',
    print_and_confirm: 'Tipărește și începe pregătirea acum',
  },
  toasts: {
    something_went_wrong: 'Ceva a mers greșit, încearcă din nou',
  },
};
